export default function UnstakeRow({
  item,
  index,
  onClaimUnstaked,
  isClaimingUnstaked,
  token
}) {
  const {
    date = "Sep 01, 2025",
    unstakedTime = "07:02 PM",
    availableIn = "00D:00H:00M",
    availableClass = "greenline",
    amount = "25,000 OASIS",
    canWithdraw = true,
    claimDate,
    claimTime,
  } = item;

  const handleWithdraw = async () => {
    if (!canWithdraw || !onClaimUnstaked) return;
    try {
      await onClaimUnstaked(index);
    } catch (error) {
      console.error("Error claiming unstaked:", error);
    }
  };

  const formatNumber = (value, decimals = 4) => {
    if (value === undefined || value === null || value === "" || isNaN(value)) return "0";
    return Number(value).toLocaleString(undefined, { maximumFractionDigits: decimals });
  };

  return (
    <tr>
      <td>
        <div className="span_tab">
          <p>{date}</p>
          <span>{unstakedTime}</span>
        </div>
      </td>

      <td>
        <p className={availableClass}>{availableIn=="Available now"&& !canWithdraw?"Not Available":availableIn}</p>
      </td>

      <td>
        <p>{formatNumber(amount) + " " + token}</p>
      </td>
      <td>
        <button
          className={
            canWithdraw
              ? "bluebutton"
              : availableIn === "Available now"
                ? "graybutton"
                : "bluebuttonlight"
          }
          onClick={handleWithdraw}
          disabled={!canWithdraw || isClaimingUnstaked}
        >
          {isClaimingUnstaked
            ? "Claiming..."
            : availableIn === "Available now" && !canWithdraw
              ? "Claimed"
              : canWithdraw
                ? "Withdraw"
                : "Locked"}
        </button>
      </td>

    </tr>
  );
}
